import { Avatar, TableRow } from '@mui/material';
import { StyledTableCell } from '../../../../../shared/components/CustomTable/Styled';
import { formatTimestamp } from '../../../../ProductOrder/detail/EventLog';
import { stringAvatar } from '../../../../UserList/Content/UserTable';
import Status from '../../../../../shared/components/Status';
import { StyledNavLink } from '../../../../../shared/styled/TableStyles';

const HistoryTableRows = ({ item }: { item: any }) => {
    const textCategory = item.transaction_type === 'OUT' ? 'Xuất kho' : 'Nhập kho';
    const colorCategory = item.transaction_type === 'OUT' ? 'INFO' : 'WARNING';

    // Function to render the source link or empty string based on type
    const renderSourceLink = () => {
        if (!item.source_info) {
            return " ";
        }

        const { type, id, name } = item.source_info;
        
        switch (type) {
            case 'materialsimport':
                return 'Nhập thủ công';
            case 'productorder':
                return (
                    <StyledNavLink to={`/product-orders/${id}`}>
                        {name}
                    </StyledNavLink>
                );
            
            case 'materialorder':
                return (
                    <StyledNavLink to={`/material-orders/${id}`}>
                        {name}
                    </StyledNavLink>
                );
            
            case 'outsourceorder':
                return (
                    <StyledNavLink to={`/outsource-orders/${id}`}>
                        {name}
                    </StyledNavLink>
                );
                
            case 'materialsexport':
                return "Xuất thủ công";
                
            default:
                // Default case - no link, just show the name if available
                return name || " ";
        }
    };

    return (
        <TableRow>
            <StyledTableCell align="left">
                {formatTimestamp(item.transaction_date)}
            </StyledTableCell>
            <StyledTableCell align="left">{item.quantity}</StyledTableCell>
            <StyledTableCell align="left">
                <Status
                    colorTheme={colorCategory}
                    text={textCategory}
                    width={'72px'}
                />
            </StyledTableCell>
            <StyledTableCell align="left">
                {renderSourceLink()}
            </StyledTableCell>
            <StyledTableCell align="left">
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Avatar
                        {...stringAvatar(item.performed_by.username)}
                        sx={{ width: '32px', height: '32px', fontSize: '16px' }}
                    />
                    <span>{item.performed_by.display_name}</span>
                </div>
            </StyledTableCell>
        </TableRow>
    );
};

export default HistoryTableRows;
